import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSliderModule } from '@angular/material/slider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

const MATERIAL_COMPONENTS = [
	MatFormFieldModule,
	MatSelectModule,
	MatProgressBarModule,
	MatDialogModule,
	MatCheckboxModule,
	MatTooltipModule,
	MatSlideToggleModule,
	MatSnackBarModule,
	MatProgressSpinnerModule,
	MatSliderModule
];

@NgModule({
	declarations: [],
	imports: [CommonModule, ...MATERIAL_COMPONENTS],
	exports: [...MATERIAL_COMPONENTS]
})
export class MaterialModule { }
